export default __webpack_public_path__ + "static/media/BzcLogo1.62103cf8.svg";